"use client";

import { useEffect } from "react";

import { observer } from "mobx-react-lite";

import { useStore } from "@/store";

import type { ReactNode } from "react";

export const RedirectIfLoggedIn = observer(function RedirectIfLoggedIn({
  children,
}: {
  children: ReactNode;
}) {
  const { auth, signInFlow } = useStore();

  // Redirect back if the user is already logged in.
  useEffect(() => {
    let cancelled = false;

    async function run() {
      if (auth.status === "ready" && auth.isLoggedIn) {
        const isRedirectResult = await auth.getRedirectResult();
        if (!isRedirectResult && !cancelled) {
          signInFlow.redirectAfterLogin();
        }
      }
    }

    run();

    return () => {
      cancelled = true;
    };
  }, [auth, auth.status, auth.isLoggedIn, signInFlow]);

  return children;
});
